import React, { useEffect, useState } from 'react';
import axiosInstance from '../../../config/axiosInstance';
import {
  Box,
  Text,
  VStack,
  Spinner,
  HStack,
  Avatar,
  Stack,
  Flex,
} from '@chakra-ui/react';
import { StarIcon } from '@chakra-ui/icons';

const Review1 = ({ productId }) => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const response = await axiosInstance.get(`/api/reviews/product/${productId}`);
        setReviews(response.data);
      } catch (error) {
        console.error('Failed to fetch reviews:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchReviews();
  }, [productId]);

  if (loading) {
    return (
      <Flex justify="center" align="center" height="100vh" bg="#f2eee8">
        <Spinner size="xl" />
      </Flex>
    );
  }

  return (
    <Box bg="#f2eee8" minH="100vh" py={10} px={4}>
      <VStack spacing={6} maxW="4xl" mx="auto">
        <Text fontSize="2xl" fontWeight="bold">Customer Reviews</Text>
        {reviews.length === 0 ? (
          <Text>No reviews yet.</Text>
        ) : (
          reviews.map((review, index) => (
            <Box
              key={index}
              w="100%"
              p={5}
              shadow="md"
              borderWidth="1px"
              borderRadius="lg"
              bg="white"
            >
              <Stack direction={{ base: 'column', md: 'row' }} justify="space-between">
                <HStack>
                  <Avatar name={review.userId?.name} size="sm" />
                  <Box>
                    <Text fontWeight="bold">{review.userId?.name}</Text>
                    <HStack spacing={1} mt={1}>
                      {[...Array(5)].map((_, i) => (
                        <StarIcon
                          key={i}
                          color={i < review.rating ? 'yellow.400' : 'gray.300'}
                        />
                      ))}
                    </HStack>
                  </Box>
                </HStack>
                <Text fontSize="sm" color="gray.500">
                  {new Date(review.createdAt).toLocaleDateString()}
                </Text>
              </Stack>
              <Text mt={4}>{review.comment}</Text>
            </Box>
          ))
        )}
      </VStack>
    </Box>
  );
};

export default Review1;
